import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { cn } from '@repo/ui/lib/utils';
import type React from 'react';

export type SettingsHeaderProps = {
  title: string | React.ReactNode;
  subtitle: string | React.ReactNode;
  hideDivider?: boolean;
  children?: React.ReactNode;
  className?: string;
};

export const SettingsHeader = ({
  children,
  title,
  subtitle,
  className,
  hideDivider,
}: SettingsHeaderProps) => {
  useLocale();

  return (
    <>
      <div className={cn('mb-8 flex flex-wrap items-center justify-between gap-4', className)}>
        <div>
          <span className="raven-label">{t('workspace.settings')}</span>
          <h1>{title}</h1>

          <p className="text-muted-foreground text-sm md:mt-2">{subtitle}</p>
        </div>

        {children}
      </div>

      {!hideDivider && <hr className="mb-8 border-[#deddf0]" />}
    </>
  );
};
